/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-24 18:55:15
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
/**
 * @description: 报价单接口列表
 * @return {*}
 * @author: 胡彩丽 hucaili@qfei.cn
 */
import { BaseService } from './base-service';
class PriceService extends BaseService {
  /**
   *
   *  报价单页签--报价单列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof priceService
   */
  getPriceTabList(params) {
    console.log(params);
    return this.request({
      method: 'get',
      url: `/price_sheet/sheet/list/${params.entity}/${params.id}`,
      params
    });
  }
  /**
   * @description: 作废报价单
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delPriceSheet(data) {
    return this.request({
      method: 'get',
      url: `/price_sheet/del`,
      params: data
    });
  }
}
export const priceService = new PriceService();
